import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import DescriptionIcon from 'components/material-symbol/icons/Description'
import useStyles from './styles'

const OFFERING_ACTIONS = {
  LESSON_TYPE: 'Book now',
  GROUP_EVENT: 'Register',
}

export default function ChatPreview({ body, offerings, media }) {
  const classes = useStyles()

  return (
    <Box className={classes.chatPreview} data-testid="campaign-chat-preview">
      {body ? (
        <Typography component="div" className={classes.chatBubble}>
          {body}
        </Typography>
      ) : null}
      {offerings.map(offering => (
        <Box
          key={`${offering.offeringType}-${offering.id}`}
          className={classes.chatCard}
        >
          <Typography className={classes.chatCardTitle}>
            {offering.title}
          </Typography>
          <Typography className={classes.chatCardAction}>
            {OFFERING_ACTIONS[offering.offeringType]}
          </Typography>
        </Box>
      ))}
      {media.map(item =>
        item.kind === 'IMAGE' ? (
          <img
            key={item.url}
            src={item.url}
            alt={item.title || 'Campaign image'}
            className={classes.chatImage}
          />
        ) : (
          <Box
            key={item.url}
            className={classes.chatCard}
            display="flex"
            alignItems="center"
            gridGap={8}
          >
            <DescriptionIcon />
            <Typography className={classes.chatCardTitle}>
              {item.title || 'Attachment'}
            </Typography>
          </Box>
        ),
      )}
    </Box>
  )
}

ChatPreview.propTypes = {
  body: PropTypes.string,
  offerings: PropTypes.arrayOf(
    PropTypes.shape({
      offeringType: PropTypes.oneOf(['LESSON_TYPE', 'GROUP_EVENT']).isRequired,
      id: PropTypes.string.isRequired,
      title: PropTypes.string,
    }),
  ).isRequired,
  media: PropTypes.arrayOf(
    PropTypes.shape({
      kind: PropTypes.oneOf(['IMAGE', 'FILE']).isRequired,
      url: PropTypes.string.isRequired,
      title: PropTypes.string,
    }),
  ).isRequired,
}
